// import { useEffect, useState } from "react";

// import {
//   getProfilePic,
//   getModuleIcons,
// } from "service1/dashboardService";

// import type { ModuleIcon } from "../types/dashboard.types";

// const HOST_TOKEN = "my-secret-token";

// type UseDashboardReturn = {
//   isMobileMenuOpen: boolean;
//   toggleMenu: () => void;
//   handleCreateOrg: () => void;
//   profilePicURL: string | undefined;
//   moduleIcons: ModuleIcon[];
//   error: string | null;
//   Button: any;
//   loading: boolean;
// };

// export default function useDashboard(): UseDashboardReturn {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   const [profilePicURL, setProfilePicURL] =
//     useState<string | undefined>();

//   const [moduleIcons, setModuleIcons] = useState<ModuleIcon[]>([]);

//   const [error, setError] = useState<string | null>(null);

//   const [Button, setButton] = useState<any>(null);

//   const token = sessionStorage.getItem("token");

//   const toggleMenu = () =>
//     setIsMobileMenuOpen((prev) => !prev);

//   const handleCreateOrg = () => {
//     console.log("Create Organization clicked");
//   };

//   useEffect(() => {
//     import("remote_app/Button").then((mod) => {
//       setButton(() => mod.default);
//     });
//   }, []);

//   useEffect(() => {
//     if (!token) return;

//     const fetchData = async () => {
//       try {
//         const [profileData, iconsData] = await Promise.all([
//           getProfilePic(token, HOST_TOKEN),

//           getModuleIcons(token, HOST_TOKEN),
//         ]);

//         if (Number(profileData.statusType) === 1) {
//           setProfilePicURL(profileData.profilePicUrl);
//         } else {
//           setError(
//             profileData.message || "Failed to load profile"
//           );
//         }

//         if (Number(iconsData.statusType) === 1) {
//           const cleanIcons = (
//             iconsData.icons || []
//           ).filter((item: ModuleIcon) => item?.icon);

//           setModuleIcons(cleanIcons);
//         } else {
//           setError(
//             iconsData.message || "Failed to load icons"
//           );
//         }
//       } catch (err) {
//         console.error(err);

//         setError("API failed");
//       }
//     };

//     fetchData();
//   }, [token]);

//   return {
//     isMobileMenuOpen,
//     toggleMenu,
//     handleCreateOrg,
//     profilePicURL,
//     moduleIcons,
//     error,
//     Button,
//     loading: !Button,
//   };
// }










import {
  useEffect,
  useState,
  type ComponentType,
} from "react";

import {
  getProfilePic,
  getModuleIcons,
} from "service1/dashboardService";

import type {
  ModuleIcon,
} from "../types/dashboard.types";



type RemoteComponent =
  ComponentType<Record<string, unknown>>;

type UseDashboardReturn = {
  isMobileMenuOpen: boolean;
  toggleMenu: () => void;
  handleCreateOrg: () => void;
  profilePicURL: string | undefined;
  moduleIcons: ModuleIcon[];
  error: string | null;
  Button: RemoteComponent | null;
  loading: boolean;
};

export default function useDashboard():
UseDashboardReturn {
const token =
  sessionStorage.getItem("token");

const authToken =
  sessionStorage.getItem("AUTH_TOKEN");
  const [
    isMobileMenuOpen,
    setIsMobileMenuOpen,
  ] = useState(false);

  const [
    profilePicURL,
    setProfilePicURL,
  ] = useState<
    string | undefined
  >();

  const [
    moduleIcons,
    setModuleIcons,
  ] = useState<ModuleIcon[]>([]);

  const [error, setError] =
    useState<string | null>(null);

  const [Button, setButton] =
    useState<
      RemoteComponent | null
    >(null);



  const toggleMenu = (): void => {

    setIsMobileMenuOpen(
      (prev) => !prev
    );

  };

  const handleCreateOrg =
    (): void => {

    console.log(
      "Create Organization clicked"
    );

  };

  useEffect(() => {

    import("remote_app/Button").then(
      (mod) => {

        setButton(
          () =>
            mod.default as RemoteComponent
        );

      }
    );

  }, []);

 useEffect(() => {

  if (!token || !authToken) return;

  const fetchData =
    async (): Promise<void> => {

      try {

        const [
          profileData,
          iconsData,
        ] = await Promise.all([

          getProfilePic(
            token,
            authToken
          ),

          getModuleIcons(
            token,
            authToken
          ),

        ]);

        if (
          Number(
            profileData.statusType
          ) === 1
        ) {

          setProfilePicURL(
            profileData.profilePicUrl
          );

        } else {

          setError(
            profileData.message ||
            "Failed to load profile"
          );

        }

        if (
          Number(
            iconsData.statusType
          ) === 1
        ) {

          const cleanIcons =
            (
              iconsData.icons || []
            ).filter(
              (
                item: ModuleIcon
              ) => item?.icon
            );

          setModuleIcons(
            cleanIcons
          );

        } else {

          setError(
            iconsData.message ||
            "Failed to load icons"
          );

        }

      } catch (err) {

        console.error(err);

        setError("API failed");

      }
    };

  fetchData();

}, [token, authToken]);

  return {
    isMobileMenuOpen,
    toggleMenu,
    handleCreateOrg,
    profilePicURL,
    moduleIcons,
    error,
    Button,
    loading: !Button,
  };
}